<template>
  <div>
    <Header no-marquee />
    <Message id="messages" :isShow="isShow1" :isSuccess="isSuccess"
      :selected="selectedItem" :options="opt" @result="closeMsg" />
    <main class="accounts">
      <section class="contents full">
        <section class="contents__header">
          <h2>{{ $t("first-login.title") }}</h2>
        </section>
        <Reset id="reset" class="item-section" @result="isTrue" no-title />
      </section>
    </main>
    <Footer />
  </div>
</template>

<script>

import { setPageTitle, textValidation } from "@/shared"
import Header from '@/views/AppHeader'
import Footer from '@/views/AppFooter'
import Reset from "@/views/accounts/Reset"
import Message from "@/components/AppMessage"

export default {
  name: "FirstLogin",
  components: {
    Header,
    Footer,
    Reset,
    Message
  },
  mixins: [setPageTitle, textValidation],

  data() {
    return {
      isShow1: false,
      isSuccess: false,
      selectedItem: "",
      opt: []
    }
  },
  methods: {
    closeMsg() {
      this.isShow1 = false
    },
    isTrue(v) {
      console.log("isTrue", v)
      this.selectedItem = v.name
      this.opt = v.affid || ""
      this.isShow1 = true
      if (v.check) {
        this.isSuccess = true
      } else {
        this.isSent = this.isSuccess = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.contents__header {
  text-align: center;
  margin: 14em 0 4em;

  @media (max-width: 992px) {
    margin: 7em 0 4em;
  }
}
</style>